/* eslint-disable */

import React, { useEffect, useState } from "react";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import "./styles.scss";

const ValidatedTextInput = (props) => {
  const [errorMessage, setErrorMessage] = useState(null);
  const [errorMessageText, setErrorMessageText] = useState(null);
  const [inputValue, setInputValue] = useState(props.value);
  const [inputIsValid, setInputIsValid] = useState(true);
  const [hasInputChanged, setHasInputChanged] = useState(false);
  const [inputClassNames, setinputClassNames] = useState(props.inputClassNames);

  const handleInputOnBlur = async (event) => {
    if (hasInputChanged) {
      setHasInputChanged(false);
      event.persist();
      if (inputValue === "") {
        setInputIsValid(false);
        setinputClassNames(props.inputClassNames);
        return;
      }

      let isValid = false;

      if (props.validator) {
        try {
          isValid = await props.validator(inputValue);
        } catch (err) {
          throw err;
        }
      } else {
        isValid = true;
      }

      setInputIsValid(isValid);

      if (isValid) {
        setErrorMessage(null);

        setinputClassNames(
          props.inputClassNames + " input-text--primary-valid"
        );
        if (props.onBlur) {
          props.onBlur(event);
        }
      } else {
        setinputClassNames(props.inputClassNames + " w");
      }
    }
  };

  const removeValidationState = () => {
    setinputClassNames(props.inputClassNames);
  };

  useEffect(() => {
    setInputValue(props.value);
  }, [props.value]);

  useEffect(() => {
    setErrorMessageText(props.errorMessage);
  }, [props.errorMessage]);

  const handleInputChange = (event) => {
    if (event.target.value !== inputValue) {
      setInputValue(event.target.value);
      setHasInputChanged(true);
    }

    props.handleInputChange(event);
  };
  let styles = {
    width: "100%",
  };

  function renderTooltip(handledprops) {
    return (
      <Tooltip id="button-tooltip" {...handledprops}>
        {props.tooltip_text}
      </Tooltip>
    );
  }

  return (
    <div
      style={props.validator ? { ...styles, paddingBottom: "10px" } : styles}
    >
      {props.displayName && (
        <label
          className="ps-validated-text-input__label"
          style={props.labelStyles ? props.labelStyles : {}}
          htmlFor=""
        >
          {props.displayName}
        </label>
      )}

      {props.tooltip_text && (
        <OverlayTrigger
          placement="right"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip}
        >
          <i
            className="material-icons"
            style={{
              fontSize: "18px",
              paddingLeft: "8px",
            }}
          >
            info
          </i>
        </OverlayTrigger>
      )}
      <input
        className={inputClassNames}
        placeholder={props.placeholder}
        type={props.type}
        name={props.name}
        readOnly={props.readOnly}
        onBlur={handleInputOnBlur}
        onChange={handleInputChange}
        onFocus={removeValidationState}
        value={inputValue}
        style={props.inputStyles ? props.labelStyles : {}}
      />
      {inputValue != "" && !inputIsValid && (
        <span className={"errorMessage input-text--primary__error"}>
          {errorMessageText}
        </span>
      )}
    </div>
  );
};

export default ValidatedTextInput;
